<script setup lang="ts">
import { logoTitle } from '@/utils/PortalConstants';
import imageUrl from '@brand-assets/logo-small.svg';
</script>

<template>
  <img
    :class="$style.sideBarSmallLogoImg"
    data-testid="sideBarSmallLogoImg"
    :src="imageUrl"
    :alt="logoTitle"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.sideBarSmallLogoImg {
  height: 23px;
}
</style>
